import { useWatch } from 'react-hook-form/dist/index.ie11';
import { ReportingOption } from 'src/components/enterprise/features/Corporate/components/Form/types/CorporateForm';

export type UseGrubhubSeamlessPlusControlReturnType = {
  showEmployeeWarning: boolean;
};

export function useReportingRequirementWrapper(): UseGrubhubSeamlessPlusControlReturnType {
  const { reporting: reportingOption } = useWatch({
    name: ['reporting'],
  });

  return {
    showEmployeeWarning:
      reportingOption === ReportingOption.DEPARTMENTS_REPORTING_OPTION,
  };
}
